import React from 'react';

export const Link = ({ adress, icon, title }) => {
  return (
    <a href={adress}>
      <i className={`${icon} link`} title={title}></i>
    </a>
  );
};
